const config = {
  PRODUCTION: {
    apiUrl: 'https://rdvenligneprod.azure-api.net',
    subscriptionKey: '59eb3998fde84063a5108fe63f2d0f3b',
    imageStorage: 'https://rdvenligneprod94a7.blob.core.windows.net/therapist-image/',
  },
  QA: {
    apiUrl: 'https://perdvenlignedev.azure-api.net',
    subscriptionKey: '1971ce9c33ad4f1d9ab20882cc8a60dd',
    imageStorage: 'https://rdvenligne8032.blob.core.windows.net/therapist-image/',
  },
  DEV: {
    apiUrl: 'https://perdvenlignedev.azure-api.net',
    subscriptionKey: '1971ce9c33ad4f1d9ab20882cc8a60dd',
    imageStorage: 'https://rdvenligne8032.blob.core.windows.net/therapist-image/',
  },
  DEVELOPMENT: {
    apiUrl: 'https://perdvenlignedev.azure-api.net',
    subscriptionKey: '1971ce9c33ad4f1d9ab20882cc8a60dd',
    imageStorage: 'https://rdvenligne8032.blob.core.windows.net/therapist-image/',
    // apiUrl: 'https://physioextra-qa-api.azure-api.net',
    // subscriptionKey: 'f4063f2d573b45a6922e61e56eb4a7fd',
    // imageStorage: 'https://rdvenligneprod94a7.blob.core.windows.net/therapist-image/',
  },
  LOCALES: ['en', 'fr'],
  LOCAL_STORAGE_KEYS: {
    SESSION: 'session',
  },
};

export const domainTheme = (hostname) => {
  switch (hostname) {
    // case 'localhost':
    //   return {
    //     main: '#24426b',
    //     logo: '/static/images/logo-PHMAUR.png',
    //     code: 'PHMAUR',
    //   };
    // case 'reservation.physioextra.ca':
    //   return {
    //     main: '#00AEF0',
    //     logo: '/static/images/logo-DEFAULT.svg',
    //     code: 'PHEXT',
    //   };
    case 'reservation.physio-estrie.ca':
      return {
        main: '#701100',
        logo: '/static/images/logo-PHEST.png',
        code: 'PHEST',
        locale: 'PHEST',
      };
    case 'reservation.physiochamplain.ca':
      return {
        main: '#36b0ca',
        logo: '/static/images/logo-PHCHAMP.png',
        code: 'PHCHAMP',
        locale: 'PHCHAMP',
      };
    case 'reservation.physiomauricie.ca':
      return {
        main: '#24426b',
        logo: '/static/images/logo-PHMAUR.png',
        code: 'PHMAUR',
        locale: 'PHMAUR',
      };
    // case 'red-pebble-065ca3d0f.azurestaticapps.net':
    //   return {
    //     main: '#00AEF0',
    //     logo: '/static/images/logo-DEFAULT.svg',
    //     code: 'DEV',
    //   };
    // case 'white-plant-0558afe0f.azurestaticapps.net':
    //   return {
    //     main: '#00AEF0',
    //     logo: '/static/images/logo-DEFAULT.svg',
    //     code: 'QA',
    //   };
    default:
      return {
        main: '#00AEF0',
        logo: '/static/images/logo-DEFAULT.svg',
        code: 'DEFAULT',
      };
  }
};

export const paths = {
  private: '/private',
  login: '/login',
};

export const stepSlugs = [
  'reasonForVisit',
  'availabilities',
  'finalization',
  'confirmation',
];

export const servicesIconsCodes = ['PH', 'MA', 'OS', 'AC', 'CNESST', 'PO', 'SP', 'PE'];

export const maxWidth = 1200;

export const availabilitiesPeriod = { nb: 3, unit: 'month' };

// DEV ONLY: bypass de l'authentification Microsoft en environnement dev.
// Actif uniquement quand APP_ENV vaut DEV (site déployé) ou DEVELOPMENT (local).
// En prod APP_ENV vaut PRODUCTION → isDevAuthBypass est false et la branche
// est éliminée du bundle par DefinePlugin.
export const isDevAuthBypass = ['DEV', 'DEVELOPMENT'].includes(process.env.APP_ENV);
export const DEV_BYPASS_EMAIL = 'sp.rb@integratik.com';
export const DEV_BYPASS_JWT = `DEV_BYPASS:${DEV_BYPASS_EMAIL}`;

export default config;
